import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

import { useLang } from '../context/LangContext';

import agua from '../assets/services/agua.png';
import cocina from '../assets/services/cocina.png';
import gas from '../assets/services/gas.png';
import internet from '../assets/services/internet.png';
import lavanderia from '../assets/services/lavanderia.png';
import limpieza from '../assets/services/limpieza.png';
import luz from '../assets/services/luz.png';
import piscina from '../assets/services/piscina.png';
import tv from '../assets/services/tv.png';

import enTexts from '../translations/en.json';
import esTexts from '../translations/es.json';

const PreviewProperty = ({ accommodation }) => {
  const [showModalPreview, setShowModalPreview] = useState(false);

  const { lang } = useLang();
  const [texts, setTexts] = useState(lang === 'es' ? esTexts : enTexts);

  const serviceImages = {
    agua,
    cocina,
    gas,
    internet,
    lavanderia,
    limpieza,
    luz,
    piscina,
    tv,
  };

  const handleOpenModal = () => {
    setShowModalPreview(true);
  };

  const handleCloseModal = () => {
    setShowModalPreview(false);
  };

  const removeTilde = string => {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  return (
    <>
      <span className="cursor-pointer underline-hover" onClick={handleOpenModal}>
        {accommodation.title}
      </span>
      <Modal show={showModalPreview} onHide={handleCloseModal} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>{accommodation.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <div>
                <img
                  src={accommodation.main_image}
                  alt={accommodation.title}
                  className="img-fluid w-100 border p-1 mb-2"
                />
              </div>
              <div className="row">
                {accommodation.images.slice(0, 5).map(
                  (image, index) =>
                    image.url != accommodation.main_image && (
                      <div className="col" key={index}>
                        <img
                          src={image.url}
                          alt={`${accommodation.title} ${index}`}
                          className="img-thumb p-1 border w-100"
                        />
                      </div>
                    )
                )}
              </div>
            </div>
            <div className="col-12 mt-4 mt-sm-0">
              <div className="mt-3">
                <h5 className="mb-3 text-uppercase title-section">
                  <b>{texts.accommodations.features.title}: </b>
                </h5>
                <div className="row">
                  <div className="col-6">
                    {texts.accommodations.features.rooms}: {accommodation.rooms}
                  </div>
                  <div className="col-6">
                    {texts.accommodations.features.furnished}:{' '}
                    {accommodation.furnished ? 'Si' : 'No'}
                  </div>
                  <div className="col-6">
                    {texts.accommodations.features.bathrooms}: {accommodation.bathrooms}
                  </div>
                  <div className="col-6">
                    {texts.accommodations.features.nearest_metro}: {accommodation.closest_subway}
                  </div>
                </div>
              </div>
              <div>
                <h5 className="mt-5 mb-3 text-uppercase title-section">
                  <b>{texts.accommodations.services.title}: </b>
                </h5>
                <div className="row">
                  {Object.keys(accommodation.services)
                    .filter(service => accommodation.services[service])
                    .map(service => (
                      <div className="col-4 my-1" key={service}>
                        <img
                          src={serviceImages[removeTilde(service)]}
                          alt={service}
                          className="service-icon"
                        />
                        {texts.accommodations.services[service]}
                      </div>
                    ))}
                </div>
              </div>
              <div className="d-none d-sm-block">
                <div>
                  <h5 className="mt-5 mb-3 text-uppercase title-section">
                    <b>{texts.accommodations.contact.title}</b>
                  </h5>
                  <div>
                    {texts.accommodations.contact.name}: {accommodation.contact.name}
                  </div>
                  <div>
                    {texts.accommodations.contact.address}: {accommodation.contact.address}
                  </div>
                  <div>
                    {texts.accommodations.contact.phone}: {accommodation.contact.phone}
                  </div>
                  <div>
                    {texts.accommodations.contact.email}: {accommodation.contact.email}
                  </div>
                </div>
                <div className="mt-4 tcenter">
                  {accommodation.social_networks.facebook && (
                    <a
                      href={`https://web.facebook.com/${accommodation.social_networks.facebook}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-facebook bg-dark text-white p-2 text-center rounded-circle rrss-icon me-2"></i>
                    </a>
                  )}
                  {accommodation.social_networks.instagram && (
                    <a
                      href={`https://www.instagram.com/${accommodation.social_networks.instagram}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-instagram bg-dark text-white p-2 text-center rounded-circle rrss-icon me-2"></i>
                    </a>
                  )}
                  {accommodation.social_networks.whatsapp && (
                    <a
                      href={`https://api.whatsapp.com/send?phone=${accommodation.social_networks.whatsapp}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-whatsapp bg-dark text-white p-2 text-center rounded-circle rrss-icon me-0 me-sm-5"></i>
                    </a>
                  )}
                  {accommodation.website && (
                    <>
                      <a href={accommodation.website} target="_blank" rel="noreferrer">
                        <button className="btn btn-dark rounded-0 text-uppercase px-5">
                          {texts.accommodations.contact.visit_website}
                        </button>
                      </a>
                    </>
                  )}
                </div>
              </div>

              <div className="d-block d-sm-none">
                <div className="bg-sen text-white p-4 rounded-4 text-center text-md-start mb-4 mt-5">
                  <h2 className="mb-3 text-center">{texts.accommodations.contact.title}</h2>
                  <div className="mb-2">
                    <span className="me-md-3 d-block d-md-inline">
                      {texts.accommodations.contact.name}: {accommodation.contact.name}
                    </span>
                    <span className="d-block d-md-inline">
                      {texts.accommodations.contact.address}: {accommodation.contact.address}
                    </span>
                  </div>
                  <div className="mb-2">
                    <span className="me-md-3 d-block d-md-inline">
                      {texts.accommodations.contact.phone}: {accommodation.contact.phone}
                    </span>
                    <span className="d-block d-md-inline">
                      {texts.accommodations.contact.email}: {accommodation.contact.email}
                    </span>
                  </div>
                  {accommodation.website && (
                    <>
                      <div className="mb-4">
                        <span className="d-block d-md-inline">
                          Web: {accommodation.website.replace(/^https?:\/\//, '')}
                        </span>
                      </div>
                      <div className="text-center">
                        <a href={accommodation.website} target="_blank" rel="noreferrer">
                          <button className="btn btn-dark text-uppercase px-4 py-2 fw-bold rounded-2">
                            {texts.accommodations.contact.visit_website}
                          </button>
                        </a>
                      </div>
                    </>
                  )}
                </div>
                <div className="mt-4 text-center">
                  {accommodation.social_networks.facebook && (
                    <a
                      href={`https://web.facebook.com/${accommodation.social_networks.facebook}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i
                        className="fa fa-facebook bg-dark text-white p-2 text-center rounded-3 rrss-icon mx-2"
                        style={{
                          fontSize: '1.5rem',
                          width: '45px',
                          height: '45px',
                          lineHeight: '1.2',
                        }}
                      ></i>
                    </a>
                  )}
                  {accommodation.social_networks.instagram && (
                    <a
                      href={`https://www.instagram.com/${accommodation.social_networks.instagram}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i
                        className="fa fa-instagram bg-dark text-white p-2 text-center rounded-3 rrss-icon mx-2"
                        style={{
                          fontSize: '1.5rem',
                          width: '45px',
                          height: '45px',
                          lineHeight: '1.2',
                        }}
                      ></i>
                    </a>
                  )}
                  {accommodation.social_networks.whatsapp && (
                    <a
                      href={`https://api.whatsapp.com/send?phone=${accommodation.social_networks.whatsapp}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i
                        className="fa fa-whatsapp bg-dark text-white p-2 text-center rounded-3 rrss-icon mx-2"
                        style={{
                          fontSize: '1.5rem',
                          width: '45px',
                          height: '45px',
                          lineHeight: '1.2',
                        }}
                      ></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PreviewProperty;
